// extracted by mini-css-extract-plugin
module.exports = {"section":"CurrentBid_section__2oRi6","wrapper":"CurrentBid_wrapper__2-jFi","currentBid":"CurrentBid_currentBid__3k-Hq","leftCol":"CurrentBid_leftCol__39uuw"};